import { addToEndOfChain, replaceInChain } from "@insite/client-framework/HandlerCreator";
import updateSearchfields, {
    chain,
    DispatchUpdateSearchFields,
} from "@insite/client-framework/Store/Pages/OrderHistory/Handlers/UpdateSearchFields";

export type HandlerType = Parameters<typeof DispatchUpdateSearchFields>[0];
export type AuerOrderUpdateSearchFieldsParameter = Parameters<typeof updateSearchfields>[0] & {
    onComplete: () => {},
};

function AuerDispatchUpdateLoadParameter(props: HandlerType)  {
    const {onComplete, ...baseParameter} = props.parameter as AuerOrderUpdateSearchFieldsParameter;
    props.dispatch({
        type: "Pages/OrderHistory/UpdateSearchFields",
        parameter: baseParameter,
    });
};
replaceInChain(chain, DispatchUpdateSearchFields, AuerDispatchUpdateLoadParameter);
addToEndOfChain(chain, DispatchOnCompleteHandler);


function DispatchOnCompleteHandler(props: HandlerType) {
    (props.parameter as AuerOrderUpdateSearchFieldsParameter)?.onComplete?.()
}